export enum OfflineSyncStatus {
  Started = 'started',
  Finished = 'finished'
}
